<template>
  <div class="data-list">
    <content-panel>
      <template v-slot:search>
        <search-box class="search-box">
          <el-form
            :inline="true"
            :model="searchForm"
            ref="searchForm"
            label-width="110px"
            size="mini"
          >
            <el-form-item label="活动id" prop="activityId">
              <el-input
                v-model="searchForm.activityId"
                clearable
                type="number"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
            <el-form-item label="活动名称" prop="activityName">
              <el-input
                v-model="searchForm.activityName"
                clearable
                placeholder="请输入"
              ></el-input>
            </el-form-item>
            <el-form-item label="用户名称" prop="customerName">
              <el-input
                v-model="searchForm.customerName"
                clearable
                placeholder="请输入"
              ></el-input>
            </el-form-item>
            <el-form-item label="核销状态" prop="status">
              <el-select 
                v-model="searchForm.status" 
                clearable 
                @change="onSearch"
              >
                <el-option v-for="item in statusList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="领劵时间" prop="updatedTime">
              <q-date-picker v-model="searchForm" ref="dateRef" />
            </el-form-item>
          </el-form>
          <template v-slot:right>
            <el-button size="small" type="primary" @click="onSearch">查询</el-button>
            <el-button size="small" @click="resetSearchForm">重置</el-button>
          </template>
        </search-box>
      </template>
      <table-panel ref="tablePanel">
        <template v-slot:header-left>
          <el-button type="primary" size="small" @click="exportList">导出</el-button>
        </template>
        <el-table
          stripe
          v-loading="loading"
          ref="tableRef"
          border
          highlight-current-row
          :data="tableData"
          :height="maxTableHeight"
        >
          <el-table-column prop="activityId" label="活动id" align="center" width="90" ></el-table-column>
          <el-table-column prop="activityName" label="活动名称" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="customerName" label="用户名称" align="center" width="140" ></el-table-column>
          <el-table-column prop="createdTime" label="领券时间" align="center" width="160" ></el-table-column>
          <el-table-column prop="couponName" label="优惠券名称" align="center" width="150"></el-table-column>
          <el-table-column prop="couponFaceValue" label="优惠券面值" align="center" width="120"></el-table-column>
          <el-table-column prop="useDoorsill" label="使用门槛" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="statusName" label="状态" align="center" width="90"></el-table-column>
          <el-table-column prop="storeName" label="分享门店" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="h5UserName" label="分享职员" align="center" width="140"></el-table-column>
          <el-table-column prop="verificationStoreName" label="核销门店" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="verificationUserName" label="核销职员" align="center" width="140"></el-table-column>
          <el-table-column prop="verificationTime" label="核销时间" align="center" width="160"></el-table-column>
        </el-table>
        <template v-slot:footer>
          <div style="text-align: right">
            <el-pagination
              @size-change="onSizeChange"
              @current-change="onNumChange"
              :current-page="pageNum"
              :page-size="pageSize"
              :total="total"
              :page-sizes="[20, 50, 100, 200]"
              layout="total, sizes, prev, pager, next, jumper"
            >
            </el-pagination>
          </div>
        </template>
      </table-panel>
    </content-panel>
  </div>
</template>

<script>
import tableMixin from "@/utils/tableMixin";
export default {
  name: "couponData",
  mixins: [tableMixin],
  data() {
    return {
      searchForm: {
        activityId:'',
        activityName:'',
        customerName: "",
        startTime: "",
        endTime: "",
        status: "",
      },
      statusList: [
        {value: "",label: "全部"},
        {value: "1",label: "待核销"},
        {value: "2",label: "已核销"},
        {value: "3",label: "已过期"},
      ],
      // 表格相关
      tableData: [],
      pageSize: 20,
      pageNum: 1,
      total: 0,
      filterParam: {},
      loading: false,
    };
  },
  methods: {
    init() {
      this.onSearch();
    },
    getList() {
      this.loading = true;
      const params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        filterData: {
          ...this.filterParam,
        },
      };
      this.$api.ActivityManagement
        .getcouponTabPages(params) 
        .then(({ data: { list, total } }) => {
          this.tableData = list || [];
          this.total = total;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onSizeChange(pageSize) {
      this.pageSize = pageSize;
      // 切换每页条数后从第一页查询
      this.pageNum = 1;
      this.getList();
    },
    onNumChange(pageNum) {
      this.pageNum = pageNum;
      this.getList();
    },
    resetSearchForm() {
      this.$refs.searchForm.resetFields();
      this.filterParam = {};
      this.initDate()
      this.onSearch();
    },
    onSearch() {
      // 每次搜索都初始化搜索条件，重新添加合法的条件
      this.filterParam = {};
      for (const [key, val] of Object.entries(this.searchForm)) {
        if (typeof val !== "undefined" && val !== null && val !== "") {
          this.filterParam[key] = val;
        }
      }
      this.pageNum = 1;
      this.getList();
    },
    initDate() {
      this.searchForm.startTime = ''
      this.searchForm.endTime = ''
      this.$refs.dateRef.reset()
    },
    exportList() {
      let params = {
        ...this.filterParam,
      };
      this.$api.common.doExport("queryCouponOrderList", params).then(() => {
        this.$message.success("导出操作成功，请前往导出记录查看详情");
      });
    },
  },
  mounted() {
    this.init();
  },
};
</script>
<style lang="stylus" scoped>
  .btn  {
    padding: 5px;
  }

</style>
